import { environment } from 'src/environments/environment';

export const ICEA_FUND_NAME : string = 'MILELE TRUST FUND REGISTERED TRUSTEES-INFLOW ACCOUNT';
export const MILELE_ACCOUNT_NUM: string = '01-050-890716-01';
export const ICEA_BANK: string = 'STANDARD CHARTERED BANK KENYA LIMITED';
export const ICEA_BANK_BRANCH: string = 'CHIROMO';

export const ICEA_BANK_CODE: string = '02';
export const ICEA_BRANCH_CODE: string = '08400';
export const ICEA_CLEARING: string = 'SCBLKENXXXX';

export const PAYBILL_TRUST: number = 4230088;
export const PAYBILL_ESTATE: number = 4230099;

export const estatePlanningBrochureName: string = 'Estate Planning.pdf';
export const trustFundBrochureName: string = 'Trust Fund.pdf';

// Estate Planning
export const ICEA_ESTATE_NAME : string = 'ICEA LION TRUST COMPANY LIMITED';
export const ICEA_BANK_ESTATE: string = 'NCBA BANK KENYA';
export const ICEA_BANK_BRANCH_ESTATE: string = 'CITY CENTER';
export const ESTATE_ACCOUNT_NUM: string = '1904210066';
export const ESTATE_BANK_CODE: string = '07000';
export const ESTATE_BRANCH_CODE: string = '101';
export const ESTATE_CLEARING: string = 'CBAFKENX';

export const TRUST_CREATION_FEE: number = 350000;
export const LEGAL_REVIEW_FEE: number = 50000;
export const TAX_CONSULTATION_FEE: number = 60000;
export const INVESTMENT_CONSULTATION_FEE: number = 20000;
// Will
export const WILL_CREATIION_FEE: number = 50000;

// Whatsapp Trust Team No.
const WHATSAPP_NO: string = '254742988878';
export const WHATSAPP_MESSAGE: string = `I%20would%20like%20to%20learn%20more%20about%20Trusts.%20Please%20reach%20out%20to%20me.`;

// URL PATHS:
export const otpRequestURL: string = `/otp/request-scapi`;
export const otpValidateURL: string = `/otp/validate-scapi`;

export const banksURL: string = `/banks`;
export const bankBranchesURL: string = `/bank/branches`;

export const fundSourceURL: string = `/fund-source-scapi`;
export const purposeURL: string = `/trust-purpose`;
export const instructorOptURL: string = `/account-mandate`;
export const prefModeURL: string = `/preffered-modes`; // missing
export const upkeepURL: string = `/upkeep`;
export const businessNatureURL: string = `/business-nature`;

export const salutationsURL: string = `/salutations`;
export const countriesURL: string = `/countries`;
export const countiesURL: string = `/counties`;
export const bookCallURL: string = `/book-call-scapi`;

export const consultantsURL: string = `/consultants`;
export const intermediaryURL: string = `/intermediaries?`;

export const saveSettlorURL: string = `/trust-fund/settlor/save`; // reverted from IBM temporarily
export const saveBenURL: string = `/trust-fund/beneficiary/save`;
export const saveGuardianURL: string = `/trust-fund/guardian/save-scapi`;
export const linkGuardianBeneficiaryURL: string = `/trust-fund/guardian/link-beneficiaries-scapi`;
export const saveTrustURL: string = `/trust-fund/save`;

export const mpesaCompleteURL: string = `/trust-fund/payment/mpesa-complete`;
export const rtgsPaymentURL: string = `/trust-fund/payment/rtgs-complete`;

export const grantLetterURL: string = `/trust-fund/grant-letter`;

export const deleteRecordURL: string = `/trust-fund/record/remove-scapi`;
export const continueLaterURL: string = `/trust-fund/progress/save`;
export const continueNowURL: string = `/trust-fund/progress/resume`;

export const mpesaPaymentURL: string = `/payment/mpesa/initiate`;
export const confirmMPESAPaymentURL: string = `/payment/mpesa/confirm`;


// Estate Planning
export const bookAppointmentEstateURL: string = `/estate-planning/appointment/book`;
export const saveAppointmentSettlorsEstateURL: string = `/estate-planning/appointment/settlor/save`;
export const legalConsultationURL: string = `/estate-planning/appointment/legal-consultation`;

// Private Trusts
export const estateBeneficiaryURL: string = `/estate-planning/beneficiary/save`;
export const estateGuardianURL: string = `/estate-planning/guardian/save`;
export const estateAssetsURL: string = `/estate-planning/asset/save`;

export const privateSettlorURL: string = `/estate-planning/private-trust/settlor/save`;
export const privateTrusteeURL: string = `/estate-planning/private-trust/trustee/save`;
export const privateEnforcerURL: string = `/estate-planning/private-trust/enforcer/save`;
export const privateTrustDetailsURL: string = `/estate-planning/private-trust/save`;

export const willTestatorURL: string = `/estate-planning/will/testator/save`;
export const willExecutorURL: string = `/estate-planning/will/executor/save`;
export const willWitnessURL: string = `/estate-planning/will/witness/save`;
export const willDetailsURL: string = `/estate-planning/will/save`;

export const cacheEstateURL: string = `/estate-planning/progress/save`;
export const resumeEstateURL: string = `/estate-planning/progress/resume`;

// CARDS
export const createCardPaymentIntentURL: string = `/cards/intent`;
export const collectCardDeviceDetailsURL: string = `/cards/collections-url`;
export const checkCardEnrollmentURL: string = `/cards/check-enrollment`;
export const processCardPaymentURL: string = `/cards/process`;

export const validateDocURL: string = `/validate/document`;

// WHATSAPP CLICK TO CHAT LINK
export const whatsappChatLink: string = `https://wa.me/${WHATSAPP_NO}?text=`;
// AJUA LINK
export const ajuaSurveyURL: string = `https://feedback.ajua.com/?j=${environment.ajuaCode}&m=`


export const MPESA_BILL_PATH: string = 'MpesaDigiPaymentConf';
export const MPESA_RECEIPT_PATH: string = 'MpesaConfirmPaymentRefNo';
